import React from 'react';
import {personalInfo} from '../constants';
import {DynamicIcon} from "../helper/getIcon";
import GlassSurface from "../components/reactbits/GlassSurface"

const Hero = () => {
    return (
        <section id="home" className="hero">
            <div className="hero-content">
                <div className="eyebrow">Hi, I'm {personalInfo.firstName} {personalInfo.lastName}</div>
                <div className="hero-title">
                    <div>Software</div>
                    <div>Developer</div>
                </div>
                <div className="subtitle">The greatest skill you can develop is decreasing the time between an idea and taking action.</div>
                <ul className="social-buttons one-line">
                    <li>
                        {personalInfo.socialLinks?.GitHub && (
                            <GlassSurface
                                width={75}
                                height={75}
                                borderRadius={8}
                                className="my-custom-class"
                            >
                                <a href={personalInfo.socialLinks.GitHub} target="_blank" rel="noreferrer" onClick={() => window.umami?.track("Link Click", { location: "Hero", label: "GitHub" })}>
                                    <DynamicIcon iconLibrary={'fontAwesome'} iconName={'Github'} />
                                </a>
                            </GlassSurface>
                        )}
                    </li>
                    <li>
                        {personalInfo.socialLinks?.LinkedIn && (
                            <GlassSurface
                                width={75}
                                height={75}
                                borderRadius={8}
                                className="my-custom-class"
                            >
                                <a href={personalInfo.socialLinks.LinkedIn} target="_blank" rel="noreferrer" onClick={() => window.umami?.track("Link Click", { location: "Hero", label: "LinkedIn" })}>
                                    <DynamicIcon iconLibrary={'fontAwesome'} iconName={'Linkedin'} />
                                </a>
                            </GlassSurface>
                        )}
                    </li>
                    <li>
                        {personalInfo.email && (
                            <GlassSurface
                                width={75}
                                height={75}
                                borderRadius={8}
                                className="my-custom-class"
                            >
                                <a href={'mailto:' + personalInfo.email} target="_blank" rel="noreferrer" onClick={() => window.umami?.track("Link Click", { location: "Hero", label: "Email" })}>
                                    <DynamicIcon iconLibrary={'fontAwesome'} iconName={'Envelope'} />
                                </a>
                            </GlassSurface>
                        )}
                    </li>
                </ul>
            </div>
        </section>
    )
        ;
};

export default Hero; 